module.exports = "/_next/static/images/e48e61932b9c8d8630d033af67d2d274-challenge-the-system-xs@2x.jpg";